// node_modules
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query/react";
// services
import { authApi } from "./services/auth";
import { organizationApi } from "./services/organization";
import { userApi } from "./services/user";
import { foodStationApi } from "./services/foodStation";
import { scheduleApi } from "./services/schedule";
import { diningOptionApi } from "./services/diningOption";
import { foodStationOptionsApi } from "./services/foodStationOptions";
import { orderApi } from "./services/order";
import { statisticApi } from "./services/statistic";
import { appApi } from "./services/app";
// reducers
import stationsReducer from "./slices/stations.slice";
import appReducer from "./slices/app.slice";
import orderReducer from "./slices/order.slice";
import userReducer from "./slices/user.slice";
// middlewares
import { listenerAuthMiddleware } from "./middlewares/auth.middleware";
import { error401Middleware } from "./middlewares/error.middleware";

export const store = configureStore({
  reducer: {
    app: appReducer,
    stations: stationsReducer,
    orders: orderReducer,
    user: userReducer,
    [authApi.reducerPath]: authApi.reducer,
    [organizationApi.reducerPath]: organizationApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [foodStationApi.reducerPath]: foodStationApi.reducer,
    [scheduleApi.reducerPath]: scheduleApi.reducer,
    [diningOptionApi.reducerPath]: diningOptionApi.reducer,
    [foodStationOptionsApi.reducerPath]: foodStationOptionsApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [statisticApi.reducerPath]: statisticApi.reducer,
    [appApi.reducerPath]: appApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(error401Middleware)
      .concat(listenerAuthMiddleware.middleware)
      .concat(authApi.middleware)
      .concat(organizationApi.middleware)
      .concat(userApi.middleware)
      .concat(foodStationApi.middleware)
      .concat(scheduleApi.middleware)
      .concat(diningOptionApi.middleware)
      .concat(foodStationOptionsApi.middleware)
      .concat(orderApi.middleware)
      .concat(statisticApi.middleware)
      .concat(appApi.middleware),
});

setupListeners(store.dispatch);
